import { useCurrentUser, useSiteData } from 'modules/hooks';
import { OptionProps } from '@match/react-component-library';

interface UseBuildContactUsSC3RequestProps {
  browserSelection: string | ((selection?: OptionProps<{}> | undefined) => void);
  categorySelection: string | ((selection?: OptionProps<{}> | undefined) => void);
  deviceSelection: string | ((selection?: OptionProps<{}> | undefined) => void);
  emailAddress: string | undefined;
  nameInput: string | undefined;
  operatingSystemSelection: string | ((selection?: OptionProps<{}> | undefined) => void);
  questionText: string;
}

const useBuildContactUsSC3Request = ({
  browserSelection,
  categorySelection,
  deviceSelection,
  emailAddress,
  nameInput,
  operatingSystemSelection,
  questionText,
}: UseBuildContactUsSC3RequestProps) => {
  const currentUser = useCurrentUser();
  const siteData = useSiteData();
  const userName = siteData.handle ? siteData.handle : nameInput;
  const userId = currentUser.userId !== '0' ? currentUser.userId : 'not logged in';

  const requestBody = {
    request: {
      requester: {
        name: userName,
        email: emailAddress,
      },
      subject: categorySelection,
      comment: {
        body: questionText,
      },
      custom_fields: [
        { id: 360036223554, value: categorySelection },
        { id: 360036153433, value: browserSelection },
        { id: 360036153453, value: deviceSelection },
        { id: 360036223594, value: operatingSystemSelection },
        { id: 360036453213, value: userName },
        { id: 360036521914, value: userId },
      ],
    },
  };

  return { requestBody };
};

export default useBuildContactUsSC3Request;
